<template>
    <div class="screenConfig app-container">
        <div class="global-header-wrap">
            <h3>{{$t('org.fliqlo')}}</h3>
        </div>
        <el-card class="app-table-container" :body-style="{ padding: '20px' }">
            <div slot="header">
                 <div class="global-table-header">
                    <div class="screenConfig-header-left">
                        <list-search @listSearchEvn="listSearchEvn"/>
                    </div>
                    <div class="screenConfig-header-right">
                        <button class="global-button-style" @click="$router.push({name: 'screenConfigBatch'})">{{$t('org.batch')}}</button>
                    </div>
                </div>
            </div>
            <div class="global-body-wrap">
                <appTable :tableData="tableData" :tableProps="tableProps" @tableHandle="tableHandle"/>
            </div>

            <pagination
            :pageSize="params.limit"
            :total="total"
            @pageNum="getPageNum"/>
        </el-card>
        
    </div>
</template>

<script>
import listSearch from '@/components/listSearch'
import appTable from '@/components/appTable'
import pagination from '@/components/pagination'
import listMixin from '@/mixins/list'
export default {
    components: {
        listSearch,
        appTable,
        pagination
    },
    mixins: [listMixin],
    computed: {
        tableProps() {
            let tableProps = [{
                prop: 'name',
                label: this.$t('org.orgName')
            }, {
                prop: 'fid',
                label: 'FID'
            }, {
                prop: 'tag',
                label: this.$t('org.tag')
            }, {
                prop: 'deviceAsset.boot_anim.filename',
                obj: true,
                label: this.$t('org.powerOn')
                
            },  {
                prop: 'deviceAsset.standby.filename',
                obj: true,
                label: this.$t('org.standby')
            },  {
                prop: 'deviceAsset.poweroff.filename',
                obj: true,
                label: this.$t('org.powerOff')
            }, {
                prop: 'handle',
                label: this.$t('org.manage'),
                btn: [this.$t('commonMsg.edit')]
            }]
            return tableProps
        }
    },
    data() {
        return {
            params: {
                limit: 20,
                offset: 0
            },
            tableData: [],
            total: 0
        }
    },

    methods: {
        getList() {
            this.$http.getOrgList(this.params)
                .then(res => {
                    this.tableData = res.data.rows
                    this.total = res.data.count
                })  
        },
        edit(data) {
            this.$router.push({name: 'screenConfigEdit', query: {id:data.row.id, fid:data.row.fid, name:data.row.name}})
        }
    }
}
</script>

<style lang="scss" scoped>
.screenConfig{
    .screenConfig-header{
        padding:10px 20px;
        display: flex;
        justify-content: space-between;
    }
    .screenConfig-pagination{
        padding:10px;
        text-align: right;
    }
}
</style>

